import React, {useEffect, useState} from 'react';
import Head from 'next/head';
import getMetaTagData from '../../../src/common/services/getMetaTagData';

import cookieCutter from 'cookie-cutter';
import ServiceNotice from "../../../src/component/pc/pass/ServiceNotice";
import Axios from "axios";
import {getLnbList} from "../../../src/common/utils/passUtil";

function Coupon({ metaTagData, couponData }) {

    //jwt 토큰 관리
    const [login_jwt, setLogin_jwt] = useState();
    const [platform, setPlatform] = useState();
    const [tabType, setTabType] = useState('hold');

    //화면시작시 최초 한번 시작...
    useEffect(() => {
        const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분
        const platformCookie = cookieCutter.get('JOIN_PLATFORM');

        setLogin_jwt(LOGIN_JWT);
        setPlatform(platformCookie);

    }, []);

    const tabClickHandler = () => {
        if (tabType == 'hold') {
            setTabType('expire');
        } else {
            setTabType('hold');
        }
    };

    return (
        <>
            <Head>
                <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_PC_PASSMONEY_URL} />
                <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
                <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
                <script src='//developers.kakao.com/sdk/js/kakao.min.js' />
                <meta name='description' content={metaTagData.shareDescription} />
                <meta name='keywords' content={metaTagData.keywords} />
                <meta name='twitter:card' content='summary' />
                <noscript>Your browser does not support JavaScript!</noscript>
                <meta property='og:type' content='website' />
                <meta property='og:locale' content='ko_KR' />
                <meta property='og:site_name' content='SBS' />
                <meta property='og:title' content={metaTagData.shareTitle || ''} />
                <meta property='og:description' content={metaTagData.shareDescription || ''} />8
                <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
                <meta property='og:url' content={metaTagData.currentUrl || ''} />
                <meta name='nate:site_name' content='SBS' />
                <meta name='nate:title' content={metaTagData.shareTitle || ''} />
                <meta name='nate:description' content={metaTagData.shareDescription || ''} />
                <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
                <meta name='nate:url' content={metaTagData.currentUrl || ''} />
                <title>{metaTagData.shareTitle}</title>
            </Head>

            <div id="container" className="contents">
                <div className="passmoneyContents">
                    {getLnbList('pc')}
                    <div className="passmoneyCont_coupon">
                        <div className="curationBannerWrap" style={{backgroundColor:'#1678FF'}}>
                            <img src="/images/pass/couponBnr02.png" className="curationBanner" alt="고객님의 보유 쿠폰을 확인하세요! 다양한 할인 혜택을 받으세요!"/>
                        </div>
                        <div className="tabListWrap_coupon">
                            <a href="#none" className={`tabBtn ${tabType == 'hold' ? 'current' : ''}`} onClick={tabClickHandler}>보유쿠폰 <strong className="text_number">0</strong></a>
                            <a href="#none" className={`tabBtn ${tabType == 'expire' ? 'current' : ''}`} onClick={tabClickHandler}>사용완료쿠폰 <strong className="text_number">0</strong></a>
                        </div>
                        <div className="noCoupon_w">
                            <strong className="noCoupon_text">사용 가능한 쿠폰이 없습니다.</strong>
                            <span className="iconSvg_coupon"></span>
                        </div>
                        <div className="noticeList_wrap">
                            {couponData.service_notice && (<ServiceNotice data={couponData.service_notice}/>)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const getCouponData = async () => {
    let result = null;

    //console.log('NEXT_PUBLIC_API_COUPON_KO :>> ', process.env.NEXT_PUBLIC_API_COUPON_KO);

    try {
        const couponData = await Axios.get(process.env.NEXT_PUBLIC_API_COUPON_KO, { timeout: 3000 });
        result = couponData.data ? { ...couponData.data } : null;

        //console.log(result);

    } catch (error) {
        console.error(error);
        result = null;
    }

    return result;
};

export async function getServerSideProps(ctx) {
    // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
    const { cookies } = ctx.req;
    const { LOGIN_JWT } = cookies;
    const { JOIN_PLATFORM } = cookies;
    const { pageSection, pageCategory } = ctx.query;

    let metaTagData;
    let couponData;

    try {
        metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
        couponData = await getCouponData();
    } catch (error) {
        console.error(error);
    }

    return {
        props:{
            couponData: couponData,
            metaTagData
        }
    };
}

export default Coupon;